import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { cn } from '@/utils/cn'

interface AuthCardProps {
  title: string
  description: string
  children?: React.ReactNode
  footer?: React.ReactNode
  className?: string
}

export function AuthCard({ title, description, children, footer, className }: AuthCardProps) {
  return (
    <Card
      className={cn(
        'w-full max-w-sm rounded-lg border border-sidebar-border bg-sidebar shadow-sm',
        className,
      )}
    >
      <CardHeader className="flex flex-col items-center text-center">
        <CardTitle className="text-xl">{title}</CardTitle>
        <CardDescription className="text-sm">{description}</CardDescription>
      </CardHeader>

      {!!children && <CardContent>{children}</CardContent>}

      {!!footer && (
        <CardFooter>
          <div className="flex w-full flex-col items-center gap-2 border-t pt-4">{footer}</div>
        </CardFooter>
      )}
    </Card>
  )
}
